
export const GoodwillColumns = ['vine', 'subscriberguid',
  'packageid', 'productid', 'productcode', 'rateplanid', 'term', 'termunit',
  'type', 'grantor', 'reason'
];

export const ResultsTitle = ['Vin', 'Success', 'Api Response', 'Subscriber Guid', 'Generation', 'Region', 'Product Code', 'Product ID'];

export interface Goodwill {
  'packageID': string;
  'productID': string;
  'productCode': string;
  'ratePlanID': string;
  'term': number | string;
  'termUnit': string;
  'type': string;
  'goodwillGrantor': string;
  'goodwillReasonCode': string;
  'vin': string;
  'subscriberGuid': string;
  'region': string;
  'generation': string;
}

export const goodwillcolumnToPropertyMapping = {
  'vin': 'vin',
  'packageid': 'packageID',
  'subscriberguid': 'subscriberGuid',
  'productid': 'productID',
  'productcode': 'productCode',
  'rateplanid': 'ratePlanID',
  'term': 'term',
  'termunit': 'termUnit',
  'type': 'type',
  'grantor': 'goodwillGrantor',
  'reason': 'goodwillReasonCode',
  'region': 'region',
  'generation': 'generation',
};

export const initialGoodwill: Goodwill = {
  'packageID': '',
  'productID': '',
  'productCode': '',
  'ratePlanID': '',
  'term': 0,
  'termUnit': '',
  'type': '',
  'goodwillGrantor': '',
  'goodwillReasonCode': '',
  'subscriberGuid': '',
  'vin': '',
  'region': '',
  'generation': '',
};
